export const mapOptions = (object: { id: string; name: string }) => ({
  value: object.id,
  label: object.name,
});
